/**
 * Пагинация
 */
export default class Paging {
    constructor(page = 1, perPage = 15) {
        this.page = page;
        this.perPage = perPage;
    }

    /**
     * @returns {number}
     */
    getPage() {
        return this.page;
    }

    /**
     * @returns {number}
     */
    getPerPage() {
        return this.perPage;
    }
}
